import { trendingConstants } from '../_constants';
import * as commonAction from './commonAction';
import { trendingService, commonService } from '../_services';
import { alertActions } from '.';

export const trendingActions = {
    getTrendingList,
    deleteTrending
};

//-- getTrendingList
function getTrendingList(apiName,trendingData,) {
    
    return dispatch => {
        dispatch(commonAction.request(trendingConstants.TRENDING_LIST_REQUEST, trendingData));
        trendingService.getTrendingList(apiName, trendingData)
            .then(
                tags => {
                    
                    //console.log("Successfully",tags.data);
                    dispatch(commonAction.success(trendingConstants.TRENDING_LIST_SUCCESS, tags.data));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(trendingConstants.TRENDING_LIST_ERROR, tags.message));
                        dispatch(alertActions.error(tags.message));
                    } 
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}


//-- Delete Terms
function deleteTrending(apiName, trendingData, apiNameListing, postDataForListing) {
    return dispatch => {
        dispatch(commonAction.request(trendingConstants.TRENDING_DELETE_REQUEST, trendingData));
        commonService.withToken(apiName, trendingData)
            .then(
                tags => {
                    setTimeout(function () {
                        dispatch(getTrendingList(apiNameListing, postDataForListing));
                    }, 1000);

                    dispatch(commonAction.success(trendingConstants.TRENDING_DELETE_SUCCESS, tags));
                    dispatch(alertActions.success(tags.data.message));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(trendingConstants.TRENDING_DELETE_FAILURE, tags.message));
                        dispatch(alertActions.error(tags.message));
                    }
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}
